const ErrorCodes = {
  ROUTE_NOT_FOUND: 'ROUTE_NOT_FOUND',
  COMMON_INVALID_INPUT_DATA: 'COMMON_INVALID_INPUT_DATA',
  COMMON_NOT_FOUND: 'COMMON_NOT_FOUND',
  COMMON_UNAUTHORIZED: 'COMMON_UNAUTHORIZED',
  COMMON_INTERNAL_SERVER_ERROR: 'COMMON_INTERNAL_SERVER_ERROR',
  COMMON_SMART_CONTRACT_NOT_FOUND: 'SMART_CONTRACT_NOT_FOUND',
  COMMON_INVALID_VALUE: 'COMMON_INVALID_VALUE',
  ALERT_PACKAGE_ID_OR_LEG_ID_IS_REQUIRED: 'ALERT_PACKAGE_ID_OR_LEG_ID_IS_REQUIRED',
  AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
  AUTH_USER_NOT_EXISTS_IN_THE_AUTH: 'AUTH_USER_NOT_EXISTS_IN_THE_AUTH',
  AUTH_USER_IS_LOCKED: 'AUTH_USER_IS_LOCKED',
  AUTH_USER_NOT_FOUND: 'AUTH_USER_NOT_FOUND',
  AUTH_GROUPS_CANNOT_BE_IMPERSONATED: 'AUTH_GROUPS_CANNOT_BE_IMPERSONATED',
  AUTH_SMART_CONTRACT_USERS_NOT_CREATED: 'AUTH_SMART_CONTRACT_USERS_NOT_CREATED',
  AUTH_SMART_CONTRACT_USERS_NOT_UPDATED: 'AUTH_SMART_CONTRACT_USERS_NOT_UPDATED',
  AUTH_SMART_CONTRACT_USER_NOT_FOUND: 'AUTH_SMART_CONTRACT_USER_NOT_FOUND',
  AUTH_SMART_CONTRACT_PASSWORD_NOT_RECOVERED: 'AUTH_SMART_CONTRACT_PASSWORD_NOT_RECOVERED',
  ASYNC_STORAGE_USER_NOT_FOUND: 'ASYNC_STORAGE_USER_NOT_FOUND',
  CONSIGNEE_NOT_FOUND: 'CONSIGNEE_NOT_FOUND',
  CURRENT_BLOCK_NOT_FOUND: 'CURRENT_BLOCK_NOT_FOUND',
  OWNER_NOT_FOUND: 'OWNER_NOT_FOUND',
  CUSTOMER_NOT_FOUND: 'CUSTOMER_NOT_FOUND',
  DOCUMENT_ALREADY_IN_VAULT: 'DOCUMENT_ALREADY_IN_VAULT',
  DOCUMENT_MUST_BE_BUFFER: 'DOCUMENT_MUST_BE_BUFFER',
  DOCUMENT_DOWNLOAD_FAILED: 'DOCUMENT_DOWNLOAD_FAILED',
  DOCUMENT_NOT_FOUND: 'DOCUMENT_NOT_FOUND',
  DRIVER_NOT_ASSIGNED: 'DRIVER_NOT_ASSIGNED',
  DRIVER_NOT_FOUND: 'DRIVER_NOT_FOUND',
  EMAIL_SEND_FAILED: 'EMAIL_SEND_FAILED',
  FILENAME_NOT_FOUND: 'FILENAME_NOT_FOUND',
  HEALTH_BLOCK_TIME_EXCEEDED: 'HEALTH_BLOCK_TIME_EXCEEDED',
  HEALTH_BLOCKS_NOT_FOUND: 'HEALTH_BLOCKS_NOT_FOUND',
  INVALID_FILENAME: 'INVALID_FILENAME',
  INVALID_USER_ID: 'INVALID_USER_ID',
  INVALID_PERMISSION_TEMPLATE: 'INVALID_PERMISSION_TEMPLATE',
  LEG_SUPPLIER_IS_MISSING: 'LEG_SUPPLIER_IS_MISSING',
  LEG_DOCUMENT_ALREADY_EXISTS: 'LEG_DOCUMENT_ALREADY_EXISTS',
  LEG_IS_ALREADY_COLLECTED: 'LEG_IS_ALREADY_COLLECTED',
  LEG_IS_ALREADY_DELIVERED: 'LEG_IS_ALREADY_DELIVERED',
  LEG_MUST_BE_COLLECTED_BEFORE_DELIVERING: 'LEG_MUST_BE_COLLECTED_BEFORE_DELIVERING',
  LEG_POSITION_SHOULD_NOT_BE_NULL: 'LEG_POSITION_SHOULD_NOT_BE_NULL',
  LEG_LOGISTICS_EXPORT_PENDING: 'LEG_LOGISTICS_EXPORT_PENDING',
  LEG_LOGISTICS_EXPORT_NOT_PENDING: 'LEG_LOGISTICS_EXPORT_NOT_PENDING',
  OWNER_ID_IS_REQUIRED: 'OWNER_ID_IS_REQUIRED',
  PACKAGE_NOT_FOUND: 'PACKAGE_NOT_FOUND',
  PACKAGE_LOGISTICS_EXPORT_PENDING: 'PACKAGE_LOGISTICS_EXPORT_PENDING',
  PACKAGE_LOGISTICS_EXPORT_NOT_PENDING: 'PACKAGE_LOGISTICS_EXPORT_NOT_PENDING',
  INTEGRATION_DELETION_NOT_PENDING: 'INTEGRATION_DELETION_NOT_PENDING',
  PERMISSION_SUBJECT_INVALID: 'PERMISSION_SUBJECT_INVALID',
  PERMISSION_RESOURCE_TRAVERSING_INVALID: 'PERMISSION_RESOURCE_TRAVERSING_INVALID',
  OPERATION_NOT_GRANTED: 'OPERATION_NOT_GRANTED',
  GEOFENCE_NOT_FOUND: 'GEOFENCE_NOT_FOUND',
  PADDING_EXCEEDS_DATA_LENGTH: 'PADDING_EXCEEDS_DATA_LENGTH',
  PAYLOAD_VALIDATION_ERROR: 'PAYLOAD_VALIDATION_ERROR',
  PDF_BLOB_IS_NOT_AVAILABLE: 'PDF_BLOB_IS_NOT_AVAILABLE',
  POSITION_MUST_BE_AN_ARRAY: 'POSITION_MUST_BE_AN_ARRAY',
  REPOSITORY_INVALID_PARAMS: 'REPOSITORY_INVALID_PARAMS',
  REPOSITORY_OWNER_ID_IS_REQUIRED: 'REPOSITORY_OWNER_ID_IS_REQUIRED',
  REQUEST_TRANSACTION_TIMEOUT: 'REQUEST_TRANSACTION_TIMEOUT',
  SERVICE_IS_UNDER_MAINTENANCE: 'SERVICE_IS_UNDER_MAINTENANCE',
  SHIPMENT_IS_CANCELLED: 'SHIPMENT_IS_CANCELLED',
  SHIPMENT_IS_DRAFT: 'SHIPMENT_IS_DRAFT',
  SHIPMENT_IS_DELIVERED: 'SHIPMENT_IS_DELIVERED',
  SHIPMENT_MISSING_GEOCODING: 'SHIPMENT_MISSING_GEOCODING',
  SHIPMENT_MISSING_LEGS: 'SHIPMENT_MISSING_LEGS',
  SHIPMENT_MISSING_PACKAGES: 'SHIPMENT_MISSING_PACKAGES',
  SHIPMENT_NOT_FOUND: 'SHIPMENT_NOT_FOUND',
  SHIPPER_NOT_FOUND: 'SHIPPER_NOT_FOUND',
  SUPPLIER_IS_NOT_GROUP: 'SUPPLIER_IS_NOT_GROUP',
  SSO_ONLY: 'SSO_ONLY',
  STORAGE_DELETE_NOT_ALLOWED: 'STORAGE_DELETE_NOT_ALLOWED',
  STORAGE_DOWNLOAD_FAILED: 'STORAGE_DOWNLOAD_FAILED',
  STORAGE_FAILED_TO_GET_PRESIGNED_URL: 'STORAGE_FAILED_TO_GET_PRESIGNED_URL',
  STORAGE_FILE_ALREADY_EXISTS: 'STORAGE_FILE_ALREADY_EXISTS',
  STORAGE_FILE_NOT_FOUND: 'STORAGE_FILE_NOT_FOUND',
  TRACKER_NOT_FOUND: 'TRACKER_NOT_FOUND',
  TRACKER_SMART_CONTRACT_NOT_FOUND: 'TRACKER_SMART_CONTRACT_NOT_FOUND',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_NOT_IN_GROUP: 'USER_NOT_IN_GROUP',
  USER_IS_NOT_A_GROUP: 'USER_IS_NOT_A_GROUP',
  USER_IS_NOT_A_USER: 'USER_IS_NOT_A_USER',
  VALUE_MUST_BE_A_NUMBER: 'VALUE_MUST_BE_A_NUMBER',
  VAULT_SMART_CONTRACT_ERROR_GETTING_DOCUMENT: 'VAULT_SMART_CONTRACT_ERROR_GETTING_DOCUMENT',
  VAULT_SMART_CONTRACT_FILE_NOT_FOUND: 'VAULT_SMART_CONTRACT_FILE_NOT_FOUND',
  VAULT_SMART_CONTRACT_NOT_FOUND: 'VAULT_SMART_CONTRACT_NOT_FOUND',
  WALLET_NOT_FOUND: 'WALLET_NOT_FOUND',
  ROLE_HAS_USERS: 'ROLE_HAS_USERS',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  GROUP_HAS_USERS: 'GROUP_HAS_USERS',
  HIERARCHY_LOOP: 'HIERARCHY_LOOP',
  USER_CANNOT_BE_RECOVERED: 'USER_CANNOT_BE_RECOVERED',
  OWNERSHIP_CANNOT_BE_CHANGED: 'OWNERSHIP_CANNOT_BE_CHANGED',
  ROLE_FOR_USER_INVALID: 'ROLE_FOR_USER_INVALID',
  ROLE_FOR_SUPERADMIN_INVALID: 'ROLE_FOR_SUPERADMIN_INVALID',
  ROLE_REASSIGN_IN_PROGRESS: 'ROLE_REASSIGN_IN_PROGRESS',
  REASSIGN_QUEUE_FULL: 'REASSIGN_QUEUE_FULL',
  CANNOT_CANCEL_RUNNING_REASSIGN: 'CANNOT_CANCEL_RUNNING_REASSIGN',
  PERMISSION_CREATION_FAILED: 'PERMISSION_CREATION_FAILED',
  BRIDGE_SCOPE_VIOLATION: 'BRIDGE_SCOPE_VIOLATION',
  SUPPORT_REQUEST_CONFLICT: 'SUPPORT_REQUEST_CONFLICT',
  SUPPORT_REQUEST_NOT_FOUND: 'SUPPORT_REQUEST_NOT_FOUND',
  SUPPORT_REQUEST_INVALID_STATUS: 'SUPPORT_REQUEST_INVALID_STATUS',
} as const;

export type ValueOf<T> = T[keyof T];

export type ErrorCode = ValueOf<typeof ErrorCodes>;

export default ErrorCodes;
